import { Injectable } from '@angular/core';
import * as I from '@interfaces';
import { 
	EnvironmentService,
	ErrorService,
	FuncServiceBase,
	SpinnerService,
	UrlService,
	UtilityService,
} from '@eforall/common';

//
//  This class is generated by generate-client-shims.mjs which is called
//  during the build. DON'T CHANGE IT MANUALLY.
//

@Injectable({ providedIn: 'root' })
export class FuncService extends FuncServiceBase {

	constructor(
		env: EnvironmentService,
		errorService: ErrorService,
		spinner: SpinnerService,
		url: UrlService,
		util: UtilityService,
) {
		super(env, errorService, spinner, url, util);
	}

	public accApplication = {
		addAccApplicationStatusDeferementAndLog: this._call<{ accApplicationId: number, toAccApplicationStatusId: number, deferApplication: boolean, notes?: string }, number | undefined>('accApplication.addAccApplicationStatusDeferementAndLog'),
		closeAllNotSubmittedApplications: this._call<{ trimesterId: number }, { updatedCount: number }>('accApplication.closeAllNotSubmittedApplications'),
		getDialogData: this._call<{ accApplicationId: number }, I.AccApplicationDialogFuncData | undefined>('accApplication.getDialogData'),
		removeDeferementAndChangeStatus: this._call<{ accApplicationId: number, toStatusId: I.AccApplicationStatusId }, { success: boolean, errorMessages?: string[] }>('accApplication.removeDeferementAndChangeStatus'),
		removeOfferedSeatAccIdAndChangeStatus: this._call<{ accApplicationId: number, toStatusId?: I.AccApplicationStatusId }, { success: boolean, errorMessages?: string[] }>('accApplication.removeOfferedSeatAccIdAndChangeStatus'),
		revokeAccSeat: this._call<{ accApplicationId: number }, { success: boolean, error?: string }>('accApplication.revokeAccSeat'),
		setOfferedSeatAccId: this._call<{ accApplicationId: number, offeredAccId: number }, { success: boolean, errorMessages?: string[] }>('accApplication.setOfferedSeatAccId'),
		updateAccApplicationAssignedStaff: this._call<{ accApplicationId: number, assignedToStaffId: number | undefined }, void>('accApplication.updateAccApplicationAssignedStaff'),
		updateLanguage: this._call<{ accApplicationId: number, languageId: number }, void>('accApplication.updateLanguage'),
	};

	public accApplicationInterview = {
		addOrUpdate: this._call<{ accApplicationId: number, valuePropositionRating: number, sustainabilityRating: number, coachabilityRating: number, timeCommitmentRating: number, notes: string, }, void>('accApplicationInterview.addOrUpdate'),
	};

	public accApplicationParticipant = {
		resetVideo: this._call<{ accApplicationParticipantId: number, personId: number, uniqueVideoId: number, isDelete: boolean }, void>('accApplicationParticipant.resetVideo'),
	};

	public accEntrepreneur = {
		setClassSpeaker: this._call<{ accEntrepreneurId: number, isClassSpeaker: boolean }, void>('accEntrepreneur.setClassSpeaker'),
	};

	public accGoal = {
		addComment: this._call<{ accGoalId: number, comment: string }, number | undefined>('accGoal.addComment'),
		addGoal: this._call<I.AccGoalFormValues, number | undefined>('accGoal.addGoal'),
		editComment: this._call<{ accGoalCommentId: number, comment: string }, void>('accGoal.editComment'),
		editGoal: this._call<{ accGoalId: number, values: I.AccGoalFormValues }, void>('accGoal.editGoal'),
		getDialogData: this._call<{ accGoalId: number }, I.AccGoalDetails | undefined>('accGoal.getDialogData'),
		getGoalFormValuesById: this._call<{ accGoalId: number }, I.AccGoalFormValues | undefined>('accGoal.getGoalFormValuesById'),
	};

	public accLead = {
		markProspectAsClosed: this._call<{ isMarkedClosed: boolean, accLeadId: number }, boolean>('accLead.markProspectAsClosed', { noPageSpinner: true, label: 'UPDATING' }),
		updateAccLeadAssignedStaff: this._call<{ accLeadId: number, assignedToStaffId: number | undefined }, void>('accLead.updateAccLeadAssignedStaff'),
	};

	public accSessionAttendee = {
		sendSessionSurveyEmail: this._call<{ accSessionId: number }, void>('accSessionAttendee.sendSessionSurveyEmail'),
		set: this._call<{ accSessionId: number, ventureAndPersonIds: { accVentureId: number, personId: number }[], status: I.SessionAttendeeStatus }, void>('accSessionAttendee.set'),
	};

	public accTeam = {
		addMentorDropOut: this._call<{ accMentorId: number, values: I.DropoutUpsertValues }, void>('accTeam.addMentorDropOut'),
		addMentor: this._call<{ accTeamId: number, accId: number, personId: number, volunteerId: number }, void>('accTeam.addMentor'),
		addVentureToTeam: this._call<{ accVentureId: number, accTeamId: number }, void>('accTeam.addVentureToTeam'),
		getDialogData: this._call<{ accTeamId: number }, I.AccTeamDialogData | undefined>('accTeam.getDialogData'),
		isMentorAvailable: this._call<{ personId: number, trimesterId: number }, I.MentorAvailability>('accTeam.isMentorAvailable'),
		isVentureAvailable: this._call<{ accVentureId: number }, { existingAccTeamName: string | undefined }>('accTeam.isVentureAvailable'),
		updateMentorDropOut: this._call<{ accMentorId: number, dropoutId: number, values: I.DropoutUpsertValues }, void>('accTeam.updateMentorDropOut'),
		update: this._call<{ accTeamId: number, values: I.AccTeamUpdateValues }, void>('accTeam.update'),
	};

	public accTopicSpecialists = {
		setTopicSpecialists: this._call<{ accTopicId: number, trimesterId: number, personIds: number[] }, void>('accTopicSpecialists.setTopicSpecialists'),
	};

	public accVenture = {
		addDropout: this._call<{ accVentureId: number, values: I.DropoutUpsertValues }, void>('accVenture.addDropout'),
		addEntrepreneur: this._call<{ accVentureId: number, personId: number }, void>('accVenture.addEntrepreneur'),
		getDialogData: this._call<{ accVentureId: number }, I.AccVentureDialogData | undefined>('accVenture.getDialogData'),
		isEntrepreneurAvailable: this._call<{ personId: number }, I.EntrepreneurCurrentVenture[]>('accVenture.isEntrepreneurAvailable'),
		markGraduated: this._call<{ accVentureIds: number[] }, void>('accVenture.markGraduated'),
		removeEntrepreneur: this._call<{ accEntrepreneurId: number, personId: number, accVentureId: number }, void>('accVenture.removeEntrepreneur'),
		setDeckSubmittedUtc: this._call<{ accVentureId: number, deckSubmittedUTC: number | undefined }, void>('accVenture.setDeckSubmittedUtc'),
		setFinalEventId: this._call<{ accVentureId: number, eventId?: number }, void>('accVenture.setFinalEventId'),
		setFinalPresentationScore: this._call<{ accVentureId: number, finalPresentationScore: number }, void>('accVenture.setFinalPresentationScore'),
		setRoadmapScore: this._call<{ accVentureId: number, roadmapScore: number }, void>('accVenture.setRoadmapScore'),
		updateDropout: this._call<{ accVentureId: number, dropoutId: number, values: I.DropoutUpsertValues }, void>('accVenture.updateDropout'),
		update: this._call<{ accVentureId: number, values: I.AccVentureUpdateValues }, void>('accVenture.update'),
	};

	public accelerator = {
		getData: this._call<{ accName: string }, I.AcceleratorFuncData | undefined>('accelerator.getData'),
		setKeynoteSpeaker: this._call<{ accId: number, name: string | undefined, bio: string | undefined }, void>('accelerator.setKeynoteSpeaker'),
		updateFacilitatorScheduleLink: this._call<{ accId: number, facilitatorScheduleLink?: string }, void>('accelerator.updateFacilitatorScheduleLink'),
		updateGoogleMeetCode: this._call<{ accId: number, googleMeetCode: string | undefined }, void>('accelerator.updateGoogleMeetCode'),
	};

	public address = {
		getCountyFipsId: this._call<{ countyName: string, stateCode: string }, number | undefined>('address.getCountyFipsId'),
	};

	public admissions = {
		matching: {
			applyResults: this._call<{ trimesterId: number, data: I.AdmissionsMatchingTeamsByAccData[] }, void>('admissions.matching.applyResults'),
			getData: this._call<{ trimesterId: number }, I.AdmissionsMatchingFuncData>('admissions.matching.getData'),
		},
		teamAnnouncement: {
			getAccDetailsForTeamAnnouncement: this._call<{ trimesterId: number }, I.TeamAnnouncementAccDetails[]>('admissions.teamAnnouncement.getAccDetailsForTeamAnnouncement'),
			sendTeamAnnouncementEmail: this._call<{ trimesterId: number }, void>('admissions.teamAnnouncement.sendTeamAnnouncementEmail'),
		},
		getData: this._call<{ trimesterId: number }, I.AdmissionsFuncData>('admissions.getData'),
	};

	public advisor = {
		getPromptDetailsById: this._call<{ aiPromptId: number }, I.AIPromptDetails | undefined>('advisor.getPromptDetailsById'),
	};

	public alignment = {
		getAllAlignments: this._callNoPayload<I.Alignment[]>('alignment.getAllAlignments'),
	};

	public award = {
		addAward: this._call<{ values: I.AwardInsertValues }, void>('award.addAward'),
		deleteAward: this._call<{ awardId: number }, void>('award.deleteAward'),
		getDetailsById: this._call<{ awardId: number }, I.AwardFuncData | undefined>('award.getDetailsById'),
		getEventTypeSpecificAwardAndDecidingRole: this._call<{ eventTypeId: number }, { awardNameIds: number[], decidingRoleIds: number[] }>('award.getEventTypeSpecificAwardAndDecidingRole'),
		updateAward: this._call<{ awardId: number, value: number, notes: string }, void>('award.updateAward'),
	};

	public bulkUpdate = {
		bulkUpdate: this._call<{ bulkType: I.BulkChangeType, nextId: number }, { nextId: number, maxId: number, completed: number }>('bulkUpdate.bulkUpdate', { noPageSpinner: true, label: 'UPDATING' }),
	};

	public configuration = {
		getConfigurationData: this._call<{ trimesterId: number }, I.ConfigurationData>('configuration.getConfigurationData'),
	};

	public contactRequest = {
		addEngagementId: this._call<{ engagementId: number; contactRequestId: number }, boolean>('contactRequest.addEngagementId'),
		getContactRequestById: this._call<{ contactRequestId: number }, I.ContactRequest | null>('contactRequest.getContactRequestById'),
		updateClosedContactRequest: this._call<{ closed: boolean; contactRequestId: number }, boolean>('contactRequest.updateClosedContactRequest'),
	};

	public course = {
		getAllCourses: this._callNoPayload<I.Course[]>('course.getAllCourses'),
	};

	public delivery = {
		getData: this._call<{ trimesterId: number }, I.DeliveryFuncData>('delivery.getData'),
	};

	public dropout = {
		getDetailsById: this._call<{ dropoutId: number }, I.Dropout | undefined>('dropout.getDetailsById'),
	};

	public email = {
		addEmail: this._call<{ personId: number, email: string }, { emails: I.Email[], errorMessage?: string }>('email.addEmail'),
		removeEmail: this._call<{ personId: number, emailId: number }, I.Email[]>('email.removeEmail'),
	};

	public engagement = {
		followUp: {
			add: this._call<{ followUpPayload: I.EngagementFollowUpForm, engagementId?: number }, number | undefined>('engagement.followUp.add'),
			get: this._call<{ followUpId: number }, I.EngagementFollowUpDetail>('engagement.followUp.get'),
			reOpen: this._call<{ followUpId: number }, number | undefined>('engagement.followUp.reOpen'),
			update: this._call<{ followUpId: number, followUpPayload: I.EngagementFollowUpForm }, number | undefined>('engagement.followUp.update'),
		},
		interaction: {
			add: this._call<I.EngagementContactInteractionForm, number | undefined>('engagement.interaction.add'),
			get: this._call<{ engagementContactId: number, engagementId: number }, I.EngagementContactInteraction>('engagement.interaction.get'),
			remove: this._call<{ engagementId: number, engagementContactId: number }, I.EngagementContactInteraction | undefined>('engagement.interaction.remove'),
			update: this._call<I.EngagementContactInteractionForm, number | undefined>('engagement.interaction.update'),
		},
		add: this._call<{ engagement: I.EngagementForm, followUpId?: number }, number | undefined>('engagement.add'),
		closeEngagement: this._call<{ engagementId: number }, number | undefined>('engagement.closeEngagement'),
		getContactEngagementsByPerson: this._call<{ personId: number }, I.ContactEngagement[]>('engagement.getContactEngagementsByPerson'),
		getEngagementById: this._call<{ engagementId: number }, I.EngagementDetails | undefined>('engagement.getEngagementById'),
		reopenEngagement: this._call<{ engagementId: number }, number | undefined>('engagement.reopenEngagement'),
		update: this._call<{ engagementId: number; engagement: I.EngagementForm }, number | undefined>('engagement.update'),
	};

	public entrepreneurProspect = {
		getDialogData: this._call<{ personId: number, accProspectId: number | undefined }, I.EntrepreneurProspectDialogFuncData>('entrepreneurProspect.getDialogData'),
	};

	public event = {
		add: this._call<{ values: { eventTypeId: I.AddEventTypeId, languageId: number, accId?: number, startUTC: number, endUTC: number, toolStartUTC: number, toolEndUTC: number, link?: string, publicNotes?: string, hostPersonId: number, venueId?: number, } }, number>('event.add'),
		delete: this._call<{ eventId: number }, { success: boolean, reasons: string[] }>('event.delete'),
		getAddDialogData: this._call<{ eventTypeId: number, accId?: number }, { eventType: I.EventType, accelerator: { name: string, accId: number, facilitatorPersonId: number, facilitatorName: string, languageId: number } | undefined }>('event.getAddDialogData'),
		getClassEventsSummaryForAccId: this._call<{ accId: number }, I.EventSummary[]>('event.getClassEventsSummaryForAccId'),
		getDialogData: this._call<{ eventId: number }, I.EventDialogFuncData>('event.getDialogData'),
		update: this._call<{ eventId: number, values: { startUTC: number, endUTC: number, toolStartUTC: number, toolEndUTC: number, link?: string, publicNotes?: string, hostPersonId: number, venueId?: number, } }, void>('event.update'),
	};

	public experience = {
		generateAccClassEvents: this._call<{ accId: number }, I.EventSummary[] | undefined>('experience.generateAccClassEvents'),
		getData: this._call<{ trimesterId: number }, I.ExperienceFuncData>('experience.getData'),
	};

	public explorer = {
		note: {
			addNote: this._call<{ personId?: number, accVentureId?: number, note: I.NoteUpsertValues }, void>('explorer.note.addNote'),
			deleteNote: this._call<{ noteId: number }, void>('explorer.note.deleteNote'),
			updateNote: this._call<{ noteId: number, note: I.NoteUpsertValues }, void>('explorer.note.updateNote'),
		},
		person: {
			email: {
				addEmail: this._call<{ personId: number, email: string }, { errorMessage?: string }>('explorer.person.email.addEmail'),
				deleteEmail: this._call<{ personId: number, emailId: number }, void>('explorer.person.email.deleteEmail'),
				setPrimaryEmail: this._call<{ personId: number, emailId: number }, void>('explorer.person.email.setPrimaryEmail'),
			},
			webLink: {
				addWebLink: this._call<{ personId: number, url: string, webLinkTypeId: number }, void>('explorer.person.webLink.addWebLink'),
				updateWebLink: this._call<{ personId: number, webLinkId: number, url: string, webLinkTypeId: number, deleted: boolean }, void>('explorer.person.webLink.updateWebLink'),
			},
			getCountyFipsId: this._call<{ countyName: string, stateCode: string }, number | undefined>('explorer.person.getCountyFipsId'),
			get: this._call<{ personId: number }, I.ExploredPerson>('explorer.person.get'),
			updatePersonAddress: this._call<{ personId: number, address: I.Address }, void>('explorer.person.updatePersonAddress'),
			updatePersonDetails: this._call<{ personId: number, values: I.PersonUpdatePayload }, void>('explorer.person.updatePersonDetails'),
		},
	};

	public googleCalendar = {
		acc: {
			createClassCalendarEvents: this._call<{ accId: number }, void>('googleCalendar.acc.createClassCalendarEvents'),
			refreshClassesCalendarEventAttendees: this._call<{ accId: number }, void>('googleCalendar.acc.refreshClassesCalendarEventAttendees'),
		},
		accTeam: {
			createTeamMeetCalendarEvent: this._call<{ accTeamId: number }, void>('googleCalendar.accTeam.createTeamMeetCalendarEvent'),
			refreshAccTeamCalendarEventAttendees: this._call<{ accTeamId: number }, void>('googleCalendar.accTeam.refreshAccTeamCalendarEventAttendees'),
		},
	};

	public googleGroups = {
		createGroupsForAcc: this._call<{ accId: number }, void>('googleGroups.createGroupsForAcc'),
	};

	public jobs = {
		acc_prospect: {
			refreshAccProspectsForAllTrimesters: this._call<{}, void>('jobs.acc_prospect.refreshAccProspectsForAllTrimesters'),
			refreshAccProspects: this._call<{ trimesterId?: number }, void>('jobs.acc_prospect.refreshAccProspects'),
		},
		setAccByApplication: this._call<{ trimesterId?: number }, void>('jobs.setAccByApplication'),
		setAccByLead: this._call<{ trimesterId?: number }, void>('jobs.setAccByLead'),
		setCommitmentByApplication: this._call<{ trimesterId?: number }, void>('jobs.setCommitmentByApplication'),
		setCommitmentByLead: this._call<{ trimesterId?: number }, void>('jobs.setCommitmentByLead'),
		setMissingLmiDataForYear: this._call<{ year: number }, void>('jobs.setMissingLmiDataForYear'),
	};

	public meetings = {
		updateMeetings: this._call<{ meetingsId: number, selectedSlotsWithCount: I.SelectedSlotsWithCount }, void>('meetings.updateMeetings'),
	};

	public note = {
		addNote: this._call<{ personId?: number, accVentureId?: number, note: I.NoteUpsertValues }, void>('note.addNote'),
		deleteNote: this._call<{ noteId: number }, void>('note.deleteNote'),
		getNotes: this._call<{ personId?: number, accVentureId?: number }, I.Note[]>('note.getNotes'),
		updateNote: this._call<{ noteId: number, note: I.NoteUpsertValues }, void>('note.updateNote'),
	};

	public person = {
		getPersonDetails: this._call<{ personId: number, toEdit: boolean }, I.Person | undefined>('person.getPersonDetails'),
		setPrimaryEmail: this._call<{ personId: number, emailId: number }, I.Email[]>('person.setPrimaryEmail'),
		updateBasicInfo: this._call<{ personId: number, basicInfo: I.PersonBasicInfo }, void>('person.updateBasicInfo'),
		updateDemographics: this._call<{ personId: number, demographics: I.Demographics }, void>('person.updateDemographics'),
	};

	public tech = {
		addDropoutAndAddressData: this._callNoPayload<void>('tech.addDropoutAndAddressData'),
		getMissingHudDataCount: this._call<{ year: number }, number>('tech.getMissingHudDataCount'),
		getVideoActivities: this._callNoPayload<{ courseVideoActivityId: number, title: string, courseVersionIds: number[], timeInSeconds: number, wistiaId: string }[]>('tech.getVideoActivities'),
		migrateOldTables: this._callNoPayload<string>('tech.migrateOldTables'),
		setVideoActivityTimeInSeconds: this._call<{ courseVideoActivityId: number, timeInSeconds: number }, void>('tech.setVideoActivityTimeInSeconds'),
		testTableHelpers: this._callNoPayload<void>('tech.testTableHelpers'),
		updateAccAppSwitchoverStatusId: this._call<{ trimesterId: number }, void>('tech.updateAccAppSwitchoverStatusId'),
	};

	public trimesters = {
		getCurrentTrimester: this._call<{ trimesterWindow: I.TrimesterWindow }, I.Trimester | undefined>('trimesters.getCurrentTrimester'),
	};

	public venue = {
		add: this._call<{ address: { streetAddress: string, placeAddress: string, zipId: number, googlePlaceKey: string, latitude: number, longitude: number, officialName: string, website?: string, } }, number>('venue.add'),
		delete: this._call<{ venueId: number }, boolean>('venue.delete'),
		getDialogData: this._callNoPayload<I.VenueDialogFuncData>('venue.getDialogData'),
		update: this._call<{ venueId: number, displayedName: string, publicNotes: string | undefined, internalNotes: string | undefined }, void>('venue.update'),
	};

	public videoRecording = {
		getVideo: this._call<{ personId: number, videoId: number, type: 'applicationParticipant' | 'volunteer' }, { url: string | undefined }>('videoRecording.getVideo'),
	};

	public volunteer = {
		signup: {
			mentor: {
				add: this._call<{ volunteerId: number, trimesterId: number, selectedLanguage: I.VolunteerSelectedLanguageType }, void>('volunteer.signup.mentor.add'),
			},
		},
		topic: {
			add: this._call<I.VolunteerTopicForm, number | undefined>('volunteer.topic.add'),
			get: this._call<{ volunteerTopicId: number }, I.VolunteerTopic>('volunteer.topic.get'),
			update: this._call<I.VolunteerTopicForm, number | undefined>('volunteer.topic.update'),
		},
		addVolunteerInterview: this._call<{ interview: I.VolunteerInterviewForm, volunteerId: number }, number | undefined>('volunteer.addVolunteerInterview'),
		getVolunteerDetails: this._call<{ volunteerId: number }, I.VolunteerDetails>('volunteer.getVolunteerDetails'),
		resetVideo: this._call<{ volunteerId: number, personId: number, languageId: I.LanguageId, isDelete: boolean }, void>('volunteer.resetVideo'),
		updateMentorSchedule: this._call<{ volunteerId: number }, void>('volunteer.updateMentorSchedule'),
		updateVolunteerAssignedStaff: this._call<{ volunteerId: number, assignedToStaffId: number | undefined }, void>('volunteer.updateVolunteerAssignedStaff'),
		updateVolunteerInterviewDateTime: this._call<{ interviewDateUTC: number, volunteerId: number }, void>('volunteer.updateVolunteerInterviewDateTime'),
		updateVolunteerInterview: this._call<{ interviewId: number, interview: I.VolunteerInterviewForm }, void>('volunteer.updateVolunteerInterview'),
		updateVolunteerStatus: this._call<I.VolunteerStatusForm, void>('volunteer.updateVolunteerStatus'),
		updateVolunteerSwitchLanguage: this._call<{ volunteerId: number, fromLanguageId: I.LanguageId, toLanguageId: I.LanguageId }, void>('volunteer.updateVolunteerSwitchLanguage'),
	};

	public volunteering = {
		mentorSignUp: {
			getMentorSignup: this._call<{ volunteerSignupMentorId: number }, I.VolunteerSignupMentorDetails | undefined>('volunteering.mentorSignUp.getMentorSignup'),
			updateSignUpData: this._call<{ volunteerSignupMentorId: number, volunteerSignupMentorStatus: I.VolunteerSignupMentorStatusEnum, note: string, assignedLanguageId: I.LanguageId | undefined }, boolean>('volunteering.mentorSignUp.updateSignUpData'),
		},
		specialistSignUp: {
			addSignUp: this._call<{ volunteerId: number, specialistTopicSignupData: I.SpecialistSignUpAddData }, void>('volunteering.specialistSignUp.addSignUp'),
			assignSpecialistToTopic: this._call<{ volunteerSignupSpecialistTopicId: number, accSessionId: number, topicId: number }, void>('volunteering.specialistSignUp.assignSpecialistToTopic'),
			checkSpecialistAvailability: this._call<{ personId: number, topicId: number, languageId: number, checkForExistingSignUp?: { trimesterId: number, eventStartUTC: number, eventEndUTC: number } }, I.SpecialistAvailabilityResult>('volunteering.specialistSignUp.checkSpecialistAvailability'),
			directlyAssignSpecialistToTopic: this._call<{ personId: number, accId: number, topicId: number }, void>('volunteering.specialistSignUp.directlyAssignSpecialistToTopic'),
			getSessionTopic: this._call<{ accSessionId: number, topicId: number }, I.SessionTopicAssignmentBySession | undefined>('volunteering.specialistSignUp.getSessionTopic'),
			getSpecialistSignup: this._call<{ volunteerSignupSpecialistId: number }, I.VolunteerSignupSpecialistWithAllTopics | undefined>('volunteering.specialistSignUp.getSpecialistSignup'),
			setVolunteerSpecialistSignupStatus: this._call<{ volunteerSignupSpecialistTopicId: number, accSessionId: number, topicId: number, setToStatus: 'Pending' | 'Waitlisted' | 'Removed' }, void>('volunteering.specialistSignUp.setVolunteerSpecialistSignupStatus'),
			updateSignUpData: this._call<{ volunteerSignupSpecialistId: number, note: string }, boolean>('volunteering.specialistSignUp.updateSignUpData'),
		},
		getAllClosedVolunteerProspects: this._callNoPayload<I.VolunteerProspect[]>('volunteering.getAllClosedVolunteerProspects'),
		getVolunteeringData: this._call<{ volunteerStatus: I.VolunteerStatusId[], trimesterId: number }, I.VolunteeringData>('volunteering.getVolunteeringData'),
	};

	public webLink = {
		addWebLink: this._call<{ personId: number, url: string, webLinkTypeId: number }, I.WebLink[]>('webLink.addWebLink'),
		getWebLinks: this._call<{ personId: number }, I.WebLink[]>('webLink.getWebLinks'),
		updateWebLink: this._call<{ personId: number, webLinkToUpdate: I.WebLink }, I.WebLink[]>('webLink.updateWebLink'),
	};

	public getData = this._callNoPayload<I.FuncData>('getData');
	public getDomainData = this._callNoPayload<I.DbDomainData>('getDomainData');
}